// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Uiua","placeholdersHeader":"styles_placeholdersHeader__3_YCP","editorStyle":"styles_editorStyle__2b2un","placeholdersBox":"styles_placeholdersBox__D4tm2"};